import { makeStyles } from "@material-ui/core/styles";
export const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiOutlinedInput-adornedStart": {
      padding: "0 0 0 4px",
      // background: '#FAFAFA',
      borderBottom: "solid 2px #F3994E",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "#EDEDED",
      top: 0,
      "& legend": {
        display: "none",
      },
    },
    "& .MuiFormControl-root": {
      width: "calc(100% - 40px)",
    },
  },
  textBox: {
    "& .MuiInputBase-input": {
      height: 28,
      padding: "6px 10px 4px 4px",
      fontSize: 12,
    },
  },
  formControl: {
    width: "100%",
  },
  sendBtn: {
    width: 30,
    height: 30,
  },
}));
